/* ============================================================
   SNTB Featured Collection — JS
   Version: 4.2.0 (performance update)
   Namespace: window.SNTB (isolated, zero global conflicts)
   ============================================================ */

(function () {
  'use strict';

  if (window.SNTB && window.SNTB.initialized) return;

  window.SNTB = window.SNTB || {};
  window.SNTB.initialized = true;
  window.SNTB.carousels = {};

  /* ── Constants ── */
  const LIKES_KEY      = 'sntb_likes';
  const WISHLIST_KEY   = 'sntb_wishlist';
  const SOLD_TAB_KEY   = 'sntb_sold_progress';
  const EVENT_PRODUCT_ADDED = 'ajaxProduct:added';
  let sntbQuickViewQuantity = 1;

  /* ============================================================
     LIKE COUNTER
     ============================================================ */

  function sntbFormatLikes(n) {
    n = parseInt(n) || 0;
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace('.0', '') + 'M';
    if (n >= 1000)    return (n / 1000).toFixed(1).replace('.0', '') + 'k';
    return n.toString();
  }

  function sntbGetLikedProducts() {
    try {
      return JSON.parse(localStorage.getItem(LIKES_KEY) || '[]');
    } catch (e) { return []; }
  }

  function sntbSaveLikedProducts(list) {
    try {
      localStorage.setItem(LIKES_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function sntbToggleLike(productId, button) {
    const liked = sntbGetLikedProducts();
    const isLiked = liked.includes(productId);
    let newLiked;

    if (isLiked) {
      newLiked = liked.filter(id => id !== productId);
    } else {
      newLiked = [...liked, productId];
    }

    sntbSaveLikedProducts(newLiked);
    sntbUpdateLikeButton(button, !isLiked);
  }

  function sntbUpdateLikeButton(button, isLiked) {
    if (!button) return;

    const baseLikes  = parseInt(button.getAttribute('data-base-likes')) || 0;
    const countEl    = button.querySelector('.sntb-like-btn__count');
    const iconPath   = button.querySelector('.sntb-like-btn__icon');

    button.classList.toggle('sntb-like-btn--active', isLiked);
    button.setAttribute('aria-pressed', isLiked ? 'true' : 'false');

    const displayCount = isLiked ? baseLikes + 1 : baseLikes;
    if (countEl) countEl.textContent = sntbFormatLikes(displayCount);

    if (iconPath) {
      if (isLiked) {
        iconPath.setAttribute('fill', '#e74c3c');
        iconPath.setAttribute('stroke', '#e74c3c');
      } else {
        iconPath.setAttribute('fill', 'none');
        iconPath.setAttribute('stroke', 'currentColor');
      }
    }
  }

  function sntbInitLikeStates() {
    const liked = sntbGetLikedProducts();
    document.querySelectorAll('.sntb-like-btn').forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      const isLiked   = liked.includes(productId);
      sntbUpdateLikeButton(btn, isLiked);
    });
  }

  /* ============================================================
     SOLD COUNT TAB — Progressive random (always increases)
     ============================================================ */

  function sntbGetSoldProgress() {
    try {
      return JSON.parse(sessionStorage.getItem(SOLD_TAB_KEY) || '{}');
    } catch (e) { return {}; }
  }

  function sntbSaveSoldProgress(data) {
    try {
      sessionStorage.setItem(SOLD_TAB_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function sntbInitSoldTabs() {
    const progress = sntbGetSoldProgress();

    document.querySelectorAll('[data-sold-tab]').forEach(tab => {
      const min = parseInt(tab.getAttribute('data-sold-min'), 10);
      const max = parseInt(tab.getAttribute('data-sold-max'), 10);
      const numberEl = tab.querySelector('[data-sold-number]');
      if (!numberEl || isNaN(min) || isNaN(max) || max <= min) return;

      const card = tab.closest('.sntb-card');
      const likeBtn = card ? card.querySelector('.sntb-like-btn') : null;
      const productId = likeBtn ? likeBtn.getAttribute('data-product-id') : (min + '-' + max);

      let currentVal = progress[productId];

      if (currentVal === undefined) {
        const range = max - min;
        const startOffset = Math.floor(Math.random() * (range * 0.15));
        currentVal = min + startOffset;
      } else {
        const step = Math.floor(Math.random() * 6) + 1;
        currentVal = Math.min(currentVal + step, max);
      }

      progress[productId] = currentVal;
      numberEl.textContent = currentVal;
    });

    sntbSaveSoldProgress(progress);
  }

  /* ============================================================
     CAROUSEL
     ============================================================ */

  function sntbInitCarousel(track) {
    const sectionId = track.getAttribute('data-section-id');
    if (!sectionId || window.SNTB.carousels[sectionId]) return;

    const desktopVisible  = parseInt(track.getAttribute('data-desktop')) || 4;
    const tabletVisible   = parseInt(track.getAttribute('data-tablet'))  || 2;
    const autoplay        = track.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed   = (parseInt(track.getAttribute('data-autoplay-speed')) || 4) * 1000;

    const slides      = Array.from(track.querySelectorAll('.sntb-carousel__slide'));
    const prevBtn     = document.querySelector(`[data-carousel-prev="${sectionId}"]`);
    const nextBtn     = document.querySelector(`[data-carousel-next="${sectionId}"]`);
    const dotsEl      = document.getElementById(`sntb-carousel-dots-${sectionId}`);
    const totalSlides = slides.length;

    let currentIndex  = 0;
    let autoplayTimer = null;
    let isScrolling   = false;
    let isOnScreen    = true;
    let touchStartX   = 0;
    let touchStartY   = 0;
    let touchStartTime = 0;

    /* PERF: cache measurements; only re-measure after a real resize */
    let cachedSlideWidth = 0;
    let cachedGap = null;

    function getVisible() {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 900) return tabletVisible;
      return desktopVisible;
    }

    function getSlideWidth() {
      if (cachedSlideWidth > 0) return cachedSlideWidth;
      const slide = slides[0];
      if (!slide) return track.offsetWidth;
      const rect = slide.getBoundingClientRect();
      cachedSlideWidth = rect.width > 0 ? rect.width : slide.offsetWidth;
      return cachedSlideWidth;
    }

    function getGap() {
      if (cachedGap !== null) return cachedGap;
      cachedGap = parseFloat(getComputedStyle(track).gap) || 20;
      return cachedGap;
    }

    function scrollToIndex(index, animate) {
      const visible  = getVisible();
      const maxIndex = Math.max(0, totalSlides - visible);
      currentIndex   = Math.min(Math.max(index, 0), maxIndex);

      /* PERF: index 0 needs no measuring (offset is always 0) — avoids a forced layout on page load */
      const offset = currentIndex === 0 ? 0 : currentIndex * (getSlideWidth() + getGap());

      const isMobile = window.innerWidth <= 600;
      const behavior = (animate === false || isMobile) ? 'instant' : 'smooth';

      isScrolling = true;
      track.scrollTo({ left: offset, behavior });

      setTimeout(() => { isScrolling = false; }, behavior === 'smooth' ? 500 : 50);

      updateArrows();
      updateDots();
      updateActiveSlide();
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      /* Next arrow is never disabled: once the carousel reaches the end,
         clicking it again sends the user to the section's collection page
         instead of stopping (see goToNextOrCollection). */
    }

    function goToNextOrCollection() {
      const visible  = getVisible();
      const maxIndex = Math.max(0, totalSlides - visible);
      if (currentIndex >= maxIndex) {
        const collectionUrl = nextBtn ? nextBtn.getAttribute('data-collection-url') : '';
        if (collectionUrl) {
          window.location.href = collectionUrl;
          return;
        }
      }
      scrollToIndex(currentIndex + 1);
    }

    function updateDots() {
      if (!dotsEl) return;
      const visible   = getVisible();
      const totalDots = Math.ceil(totalSlides / visible);

      if (dotsEl.children.length !== totalDots) {
        /* PERF: build all dots off-DOM, insert once */
        const frag = document.createDocumentFragment();
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.className = 'sntb-carousel__dot';
          dot.setAttribute('aria-label', `Go to slide group ${i + 1}`);
          dot.addEventListener('click', () => { stopAutoplay(); scrollToIndex(i * getVisible()); });
          frag.appendChild(dot);
        }
        dotsEl.innerHTML = '';
        dotsEl.appendChild(frag);
      }

      const activeDotIndex = Math.floor(currentIndex / visible);
      Array.from(dotsEl.children).forEach((dot, i) => {
        dot.classList.toggle('sntb-carousel__dot--active', i === activeDotIndex);
      });
    }

    let lastActive = -1;
    function updateActiveSlide() {
      /* PERF: only touch the two slides that changed, not all of them */
      if (lastActive === currentIndex) return;
      if (lastActive >= 0 && slides[lastActive]) slides[lastActive].classList.remove('sntb-carousel__slide--active');
      if (slides[currentIndex]) slides[currentIndex].classList.add('sntb-carousel__slide--active');
      lastActive = currentIndex;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => {
      stopAutoplay();
      scrollToIndex(currentIndex - 1);
    });

    if (nextBtn) nextBtn.addEventListener('click', () => {
      stopAutoplay();
      goToNextOrCollection();
    });

    track.addEventListener('touchstart', (e) => {
      touchStartX    = e.touches[0].clientX;
      touchStartY    = e.touches[0].clientY;
      touchStartTime = Date.now();
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (isScrolling) return;

      const deltaX = touchStartX - e.changedTouches[0].clientX;
      const deltaY = touchStartY - e.changedTouches[0].clientY;
      const elapsed = Date.now() - touchStartTime;

      if (Math.abs(deltaY) > Math.abs(deltaX)) return;
      if (elapsed > 500) return;
      if (Math.abs(deltaX) < 30) return;

      stopAutoplay();
      if (deltaX > 0) goToNextOrCollection();
      else scrollToIndex(currentIndex - 1);
    }, { passive: true });

    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { stopAutoplay(); scrollToIndex(currentIndex - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); goToNextOrCollection(); e.preventDefault(); }
    });

    function startAutoplay() {
      if (!autoplay || autoplayTimer || !isOnScreen) return;   /* PERF: never stack timers, never run off-screen */
      autoplayTimer = setInterval(() => {
        if (document.hidden) return;
        const visible  = getVisible();
        const maxIndex = Math.max(0, totalSlides - visible);
        scrollToIndex(currentIndex >= maxIndex ? 0 : currentIndex + 1);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }

    const wrapper = track.closest('.sntb-fc__carousel-wrapper');
    wrapper?.addEventListener('mouseenter', stopAutoplay);
    wrapper?.addEventListener('mouseleave', startAutoplay);

    /* PERF: pause autoplay while the carousel is scrolled out of view */
    if (autoplay && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        isOnScreen = entries[0].isIntersecting;
        if (isOnScreen) startAutoplay(); else stopAutoplay();
      }).observe(track);
    }

    /* FIX: mobile browsers fire "resize" when the address bar hides during scroll.
       Only react to real width changes, so the carousel no longer jumps back to slide 1. */
    let resizeTimer;
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        cachedSlideWidth = 0;
        cachedGap = null;
        scrollToIndex(0, false);
        updateDots();
      }, 200);
    }, { passive: true });

    requestAnimationFrame(() => {
      scrollToIndex(0, false);
      startAutoplay();
    });

    window.SNTB.carousels[sectionId] = { scrollToIndex, stopAutoplay };
  }

  let sntbCarouselObserver = null;
  function sntbInitAllCarousels() {
    const tracks = document.querySelectorAll('.sntb-carousel__track');
    if ('IntersectionObserver' in window) {
      if (!sntbCarouselObserver) {
        sntbCarouselObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              sntbInitCarousel(entry.target);
              sntbCarouselObserver.unobserve(entry.target);
            }
          });
        }, { rootMargin: '200px' });
      }
      tracks.forEach(track => {
        const id = track.getAttribute('data-section-id');
        if (!window.SNTB.carousels[id]) sntbCarouselObserver.observe(track);
      });
    } else {
      tracks.forEach(track => sntbInitCarousel(track));
    }
  }

  /* ============================================================
     HEADER CART COUNT — works across themes
     ============================================================ */

  async function sntbRefreshCartCount(addedItem) {
    /* 0. Prestige / Impact / Focal (Maestrooo themes): official refresh event.
       Updates the header count and the cart drawer contents. */
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}

    let cart;
    try {
      cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
    } catch (e) { return; }
    const count = cart.item_count;

    /* 1. Horizon-family themes (Shopify's current default): header listens for "cart:update" */
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'sntb-featured-collection',
          data: { source: 'sntb-featured-collection', itemCount: count, productId: addedItem && addedItem.product_id }
        }
      }));
    } catch (e) {}

    /* 2. Dawn-family themes (Dawn, Refresh, Sense, Craft...): re-render the cart bubble */
    const dawnBubble = document.getElementById('cart-icon-bubble');
    if (dawnBubble) {
      try {
        const res  = await fetch('/?sections=cart-icon-bubble');
        const data = await res.json();
        if (data && data['cart-icon-bubble']) {
          const doc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          const fresh = doc.querySelector('.shopify-section') || doc.body;
          dawnBubble.innerHTML = fresh.innerHTML;
        }
      } catch (e) {}
    }
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sntb-featured-collection', cartData: cart });
      }
    } catch (e) {}

    /* 3. Fallback: write the number into common count elements directly */
    const selectors = [
      'cart-count', '.cart-bubble__text-count', '.cart-count-bubble span[aria-hidden="true"]',
      '[data-cart-count]', '[data-cart-item-count]', '.cart-count', '.cart__count',
      '.cart-item-count', '.header__cart-count', '.site-header__cart-count span', '.js-cart-count'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(el => {
      if (el.closest('#sntb-quick-view-modal')) return;
      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count);
      el.textContent = count;
    });
    /* Show or hide the badge to match the cart (Prestige hides it with "hidden" when empty) */
    document.querySelectorAll('.header__cart-count-badge, .cart-bubble, .cart-count-bubble').forEach(b => {
      if (count > 0) {
        b.classList.remove('visually-hidden', 'hidden', 'hide');
        b.removeAttribute('hidden');
      } else if (b.classList.contains('header__cart-count-badge')) {
        b.classList.add('hidden');
      }
    });
  }

  /* ============================================================
     CART — Add to Cart
     ============================================================ */

  async function sntbAddToCart(variantId, quantity, triggerButton) {
    if (!variantId) return;
    sntbSetButtonLoading(triggerButton, true);

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      });

      if (!addResponse.ok) {
        const err = await addResponse.json();
        throw new Error(err.description || 'Could not add to cart');
      }

      const addedProduct    = await addResponse.json();

      /* Old-theme signal (Impulse/Archetype). Optional: never block success on it. */
      try {
        const sectionsResponse = await fetch('/cart?sections=cart-ajax');
        const sectionsData     = sectionsResponse.ok ? await sectionsResponse.json() : {};
        document.dispatchEvent(new CustomEvent(EVENT_PRODUCT_ADDED, {
          bubbles: true,
          detail: {
            product: {
              ...addedProduct,
              sections: { 'cart-ajax': sectionsData && sectionsData['cart-ajax'] }
            }
          }
        }));
      } catch (e) {}

      /* Update the header cart count on any theme */
      sntbRefreshCartCount(addedProduct);

      sntbSetButtonSuccess(triggerButton);

      const modal = sntbGetModal();
      if (modal && modal.classList.contains('sntb-qv-modal--open') && triggerButton?.classList.contains('sntb-qv-modal__add-btn')) {
        setTimeout(() => sntbCloseQuickView(), 900);
      }

    } catch (err) {
      console.error('[SNTB] Add to cart failed:', err);
      sntbSetButtonError(triggerButton);
    } finally {
      setTimeout(() => sntbSetButtonLoading(triggerButton, false), 1600);
    }
  }

  function sntbSetButtonLoading(button, isLoading) {
    if (!button) return;
    if (isLoading) { button.classList.add('sntb-btn--loading'); button.disabled = true; }
    else { button.classList.remove('sntb-btn--loading', 'sntb-btn--success', 'sntb-btn--error'); button.disabled = false; }
  }
  function sntbSetButtonSuccess(button) { if (!button) return; button.classList.remove('sntb-btn--loading'); button.classList.add('sntb-btn--success'); }
  function sntbSetButtonError(button)   { if (!button) return; button.classList.remove('sntb-btn--loading'); button.classList.add('sntb-btn--error'); }

  /* ============================================================
     BUY NOW — Direct Checkout
     ============================================================ */

  async function sntbBuyNow(variantId, quantity, triggerButton) {
    if (!variantId) return;
    const qty = quantity || 1;
    if (triggerButton) {
      triggerButton.style.pointerEvents = 'none';
      triggerButton.style.opacity = '0.7';
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add to cart');
      }
      window.location.href = '/checkout';
    } catch (err) {
      console.error('[SNTB] Buy Now failed:', err);
      if (triggerButton) {
        triggerButton.style.pointerEvents = '';
        triggerButton.style.opacity = '';
      }
      alert('Something went wrong. Please try again.');
    }
  }

  /* ============================================================
     QUICK VIEW MODAL
     ============================================================ */

  /* Every featured-collection section prints its own copy of the modal (same id).
     Pick one, move it directly under <body> (the sections use CSS containment, which
     would trap a fixed-position modal), and always use that same copy afterwards. */
  function sntbGetModal() {
    let modal = window.SNTB.qvModal;
    if (modal && modal.isConnected) return modal;
    modal = document.getElementById('sntb-quick-view-modal');
    if (!modal) return null;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    window.SNTB.qvModal = modal;
    return modal;
  }

  function sntbOpenQuickView(productHandle) {
    const modal = sntbGetModal();
    if (!modal) return;

    const imageEl       = modal.querySelector('.sntb-qv-modal__image');
    const badgesEl       = modal.querySelector('.sntb-qv-modal__badges');
    const vendorEl       = modal.querySelector('.sntb-qv-modal__vendor');
    const titleEl        = modal.querySelector('.sntb-qv-modal__title');
    const reviewsEl      = modal.querySelector('.sntb-qv-modal__reviews');
    const priceEl        = modal.querySelector('.sntb-qv-modal__price');
    const comparePriceEl = modal.querySelector('.sntb-qv-modal__compare-price');
    const addBtn         = modal.querySelector('.sntb-qv-modal__add-btn');
    const buyNowBtn      = modal.querySelector('.sntb-qv-modal__buy-now-btn');
    const bodyEl         = modal.querySelector('.sntb-qv-modal__body');
    const qtyValueEl     = modal.querySelector('.sntb-qv-modal__qty-value');
    const viewFullLink   = modal.querySelector('.sntb-qv-modal__view-full-link');

    sntbQuickViewQuantity = 1;
    if (qtyValueEl) qtyValueEl.textContent = '1';

    badgesEl.innerHTML     = '';
    reviewsEl.innerHTML    = '';
    comparePriceEl.textContent = '';
    comparePriceEl.style.display = 'none';

    bodyEl.classList.add('sntb-qv-modal__body--loading');
    modal.classList.add('sntb-qv-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sntb-modal-open');

    if (viewFullLink) viewFullLink.setAttribute('href', `/products/${productHandle}`);

    if (buyNowBtn) buyNowBtn.setAttribute('href', '#');

    fetch(`/products/${productHandle}.js`)
      .then(res => res.json())
      .then(product => {
        const variant = product.variants[0];
        const onSale  = variant.compare_at_price && variant.compare_at_price > variant.price;

        imageEl.src = product.featured_image
          ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2')
          : '';
        imageEl.alt    = product.title;
        vendorEl.textContent = product.vendor || '';
        titleEl.textContent  = product.title;

        priceEl.textContent = sntbFormatMoney(variant.price);
        priceEl.style.color = onSale
          ? 'var(--sntb-price-color, #BA4444)'
          : 'var(--sntb-price-regular-color, #15221A)';

        if (onSale) {
          comparePriceEl.textContent   = sntbFormatMoney(variant.compare_at_price);
          comparePriceEl.style.display = 'inline';
          const pct       = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          const saleBadge = document.createElement('span');
          saleBadge.className = 'sntb-badge sntb-badge--sale';
          saleBadge.textContent = `Save ${pct}%`;
          saleBadge.style.cssText = 'background-color:#BA4444 !important;color:#ffffff !important;font-size:0.75rem;padding:5px 12px;border-radius:6px;font-weight:700;letter-spacing:0.05em;text-transform:uppercase;display:inline-flex;align-items:center;';
          badgesEl.appendChild(saleBadge);
        }

        if (!variant.available) {
          const soldBadge = document.createElement('span');
          soldBadge.className   = 'sntb-badge sntb-badge--sold-out';
          soldBadge.textContent = 'Sold Out';
          badgesEl.appendChild(soldBadge);
        }

        if (product.id) {
          const jdgm = document.createElement('div');
          jdgm.className = 'jdgm-widget jdgm-preview-badge';
          jdgm.setAttribute('data-id', product.id);
          reviewsEl.appendChild(jdgm);
          if (window.jdgm && window.jdgm.batchOwnerRefresh) window.jdgm.batchOwnerRefresh();
        }

        addBtn.setAttribute('data-variant-id', variant.id);
        addBtn.disabled = !variant.available;
        addBtn.classList.toggle('sntb-btn--disabled', !variant.available);
        const defaultTextEl = addBtn.querySelector('.sntb-btn__text-default');
        if (defaultTextEl) defaultTextEl.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

        if (buyNowBtn) {
          if (variant.available) {
            buyNowBtn.setAttribute('data-variant-id', variant.id);
            buyNowBtn.setAttribute('href', '#');
            buyNowBtn.style.display = 'flex';
          } else {
            buyNowBtn.style.display = 'none';
          }
        }

        bodyEl.classList.remove('sntb-qv-modal__body--loading');
      })
      .catch(err => {
        console.error('[SNTB] Quick view fetch failed:', err);
        bodyEl.classList.remove('sntb-qv-modal__body--loading');
      });
  }

  function sntbCloseQuickView() {
    /* close every open copy, so nothing can stay stuck open */
    document.querySelectorAll('.sntb-qv-modal--open').forEach(modal => {
      modal.classList.remove('sntb-qv-modal--open');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('sntb-modal-open');
  }

  function sntbFormatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function sntbUpdateQuickViewQuantity(delta) {
    const modal = sntbGetModal();
    if (!modal) return;
    const qtyValueEl = modal.querySelector('.sntb-qv-modal__qty-value');
    const buyNowBtn  = modal.querySelector('.sntb-qv-modal__buy-now-btn');
    sntbQuickViewQuantity = Math.max(1, sntbQuickViewQuantity + delta);
    if (qtyValueEl) qtyValueEl.textContent = sntbQuickViewQuantity;

    if (buyNowBtn) {
      const variantId = buyNowBtn.getAttribute('data-variant-id');
      if (variantId) {
        buyNowBtn.setAttribute('href', '#');
      }
    }
  }

  /* ============================================================
     EVENT DELEGATION
     ============================================================ */

  document.addEventListener('click', function (e) {

    /* Like button */
    const likeBtn = e.target.closest('.sntb-like-btn');
    if (likeBtn) {
      e.preventDefault();
      const productId = likeBtn.getAttribute('data-product-id');
      sntbToggleLike(productId, likeBtn);
      return;
    }

    /* Carousel arrows */
    const prevBtn = e.target.closest('[data-carousel-prev]');
    if (prevBtn) {
      const id = prevBtn.getAttribute('data-carousel-prev');
      if (window.SNTB.carousels[id]) window.SNTB.carousels[id].stopAutoplay();
      return;
    }

    const nextBtn = e.target.closest('[data-carousel-next]');
    if (nextBtn) {
      const id = nextBtn.getAttribute('data-carousel-next');
      if (window.SNTB.carousels[id]) window.SNTB.carousels[id].stopAutoplay();
      return;
    }

    /* Add to Cart (card) */
    const addBtn = e.target.closest('.sntb-add-to-cart-btn');
    if (addBtn) {
      e.preventDefault();
      sntbAddToCart(addBtn.getAttribute('data-variant-id'), 1, addBtn);
      return;
    }

    /* Quick View Add to Cart (modal) */
    const qvAddBtn = e.target.closest('.sntb-qv-modal__add-btn');
    if (qvAddBtn) {
      e.preventDefault();
      sntbAddToCart(qvAddBtn.getAttribute('data-variant-id'), sntbQuickViewQuantity, qvAddBtn);
      return;
    }

    /* Quantity +/- */
    const qtyMinus = e.target.closest('.sntb-qv-modal__qty-btn--minus');
    if (qtyMinus) { e.preventDefault(); sntbUpdateQuickViewQuantity(-1); return; }

    const qtyPlus = e.target.closest('.sntb-qv-modal__qty-btn--plus');
    if (qtyPlus) { e.preventDefault(); sntbUpdateQuickViewQuantity(1); return; }

    /* Quick View Open */
    const qvTrigger = e.target.closest('.sntb-quick-view-btn');
    if (qvTrigger) {
      e.preventDefault();
      sntbOpenQuickView(qvTrigger.getAttribute('data-product-handle'));
      return;
    }

    /* Buy Now (modal) */
    const buyNowBtn = e.target.closest('.sntb-qv-modal__buy-now-btn');
    if (buyNowBtn) {
      e.preventDefault();
      const variantId = buyNowBtn.getAttribute('data-variant-id');
      sntbBuyNow(variantId, sntbQuickViewQuantity, buyNowBtn);
      return;
    }

    /* Quick View Close */
    if (e.target.closest('.sntb-qv-modal__close') || e.target.classList.contains('sntb-qv-modal__overlay')) {
      sntbCloseQuickView();
      return;
    }

  });

  /* Escape key closes modal */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') sntbCloseQuickView();
  });

  /* ── Init ── */
  function sntbInit() {
    sntbInitLikeStates();
    sntbInitAllCarousels();
    sntbInitSoldTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sntbInit);
  } else {
    sntbInit();
  }

  /* Shopify Theme Editor reinit */
  document.addEventListener('shopify:section:load',   () => { sntbInitAllCarousels(); sntbInitLikeStates(); });
  document.addEventListener('shopify:section:select', () => { sntbInitAllCarousels(); });

})();